module.exports = __webpack_public_path__ + "img/campaign-icon.3861ab16.svg";